import { utagLinkCart } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { cart } from '../config';
import CartBaseLayoutView from '../../baseViews/LayoutView';
import OverviewEmptyLayoutTemplate from '../templates/OverviewEmptyLayoutTemplate';
import dynamicImport from '../../../../features/webpack/dynamicImport.macro';

const trackCartEvents = utagLinkCart();

const OverviewEmptyLayout = CartBaseLayoutView.extend({
	JSXTemplate: OverviewEmptyLayoutTemplate,
	regions: {},
	ui: {
		importCartLink: '#emptyCartImport',
		skuOnTheFlyLink: '.skuOnFlyContainer button',
		continueShopping: '.continueShopping'
	},
	events: {
		'click @ui.continueShopping': 'continueShoppingClick',
		'click @ui.importCartLink': 'navigateToImportCart',
		'click @ui.skuOnTheFlyLink': 'showSkuOnTheFlyModal'
	},
	initialize () {},
	templateHelpers () {

		const { globals, pageData } = window.lp;
		const {
			consultantPhoneNumber, isCustomerService, isKiosk, isLoggedIn
		} = globals;

		const helpers = {
			consultantPhoneNumber,
			continueShoppingUrl: cart.continueShoppingUrl,
			isCustomerService,
			isLoggedIn,
			showChat: !isCustomerService && !isKiosk && pageData.isChatToggleOn,
			showSkuOnTheFly: cart.showSkuOnTheFly,
			signInUrl: cart.signInUrl
		};

		return helpers;

	},
	onRender () {

		if (window.lp.globals.isCustomerService) {

			dynamicImport('desktop/cart/overview-AddSkuView', './AddSkuView').then((module) => {

				const AddSkuView = module.default;
				// Empty Cart Add Sku
				const addSkuViewEmptyCart = new AddSkuView({
					el: '#addSkuContainerEmptyCart'
				});
				addSkuViewEmptyCart.render();

			});

		}

	},
	navigateToImportCart () {

		if (window.lp.globals.isEmployeeConnectedAsCustomer) {

			$(cart).trigger('selectCartToImport');

		} else {

			window.location.href = '/connectascustomer/assetsearch?sourcepage=cart';

		}
		return false;

	},
	showSkuOnTheFlyModal (e) {

		e.preventDefault();

		const $this = $(e.target);

		$this.lpModal({
			onInit: true,
			src: $this.attr('data-src'),
			width: 600,
			height: 410
		});

	},
	continueShoppingClick () {

		trackCartEvents({
			eventAction: 'Empty-Click-Continue-Shopping'
		});

		setGenericEvent({ event_name: 'cart_shop_click' });

	}
});

export default OverviewEmptyLayout;
